<template>
  <div class="common-page-shell">
    <PageHeader
      :title="title"
      :subtitle="subtitle"
      :actions="actions"
      @action="emitAction"
    >
      <template v-if="$slots.left" #left>
        <slot name="left" />
      </template>

      <template v-if="$slots.actions" #actions="slotProps">
        <slot name="actions" v-bind="slotProps" />
      </template>
    </PageHeader>

    <div class="common-page-shell__content">
      <slot name="content">
        <slot name="metrics"></slot>
        <slot name="toolbar"></slot>
        <slot name="tabs"></slot>
        <slot name="table"></slot>
      </slot>
    </div>

    <slot name="modal"></slot>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader.vue';

export default {
  name: 'CommonPageShell',
  components: {
    PageHeader,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['action'],
  methods: {
    emitAction(action) {
      this.$emit('action', action);
    },
  },
};
</script>

<style scoped>
.common-page-shell {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.common-page-shell__content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

@media (max-width: 767px) {
  .common-page-shell__content {
    padding: 12px;
  }
}
</style>
